import { render, staticRenderFns } from "./expertList.vue?vue&type=template&id=1d2e531d"
import script from "./expertList.vue?vue&type=script&lang=js"
export * from "./expertList.vue?vue&type=script&lang=js"
import style0 from "./expertList.vue?vue&type=style&index=0&id=1d2e531d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports